import { GridCellParams } from '@mui/x-data-grid-pro';
import { Icon } from '../../Atoms/Icon';
import { GridCustomColDef } from '../../types';
import { TextSpan } from '../../Atoms/Text';
import { getDate, getFormattedDate } from '../../../utils/helpers';
import { RecordLink } from '../../Atoms/RecordLink';

export const TicketCols: GridCustomColDef[] = [
  {
    type: 'singleSelect',
    flex: 1,
    width: 75,
    field: 'number',
    headerName: 'Number',
    renderCell: (params: GridCellParams) => (
      <RecordLink to={`/ticket/${params.row.id}`}>
        <div className="flex items-center">
          <Icon
            className="p-3 mr-1"
            type="ticketMed"
          />
          <TextSpan
            color="indigo"
            size="sm14">
            {params.value as string}
          </TextSpan>
        </div>
      </RecordLink>
    )
  },
  {
    field: 'inquiryType',
    headerName: 'Inquiry Type',
    type: 'singleSelect',
    flex: 1
  },
  {
    field: 'status',
    headerName: 'Status',
    type: 'singleSelect',
    width: 75,
    flex: 1
  },
  {
    headerName: 'Status Date',
    field: 'statusDate',
    type: 'singleSelect',
    valueFormatter: (value) => {
      return getFormattedDate(value, 'LLL');
    },
    valueGetter: (value) => {
      return getDate(value).getTime();
    },
    width: 175,
    flex: 1
  },
  {
    field: 'assignedTo.email',
    headerName: 'Assigned To',
    renderCell: (params: GridCellParams) => (
      <span title={params.row.assignedTo?.email || ''}>{params.value as string}</span>
    ),
    valueGetter: (_value, row) => `${row?.assignedTo?.firstName || ''} ${row?.assignedTo?.lastName || ''}`,
    width: 175,
    flex: 1
  },
  {
    field: 'supplierName',
    headerName: 'Supplier',
    type: 'singleSelect',
    width: 75,
    flex: 1
  },
  {
    field: 'tsdName',
    headerName: 'TSD',
    type: 'singleSelect',
    width: 75,
    flex: 1
  }
];

export const CustomerCols: GridCustomColDef[] = [
  {
    type: 'singleSelect',
    flex: 2,
    width: 175,
    field: 'name',
    headerName: 'Name',
    renderCell: (params: GridCellParams) => (
      <RecordLink to={`/customer/${params.row.id}`}>
        <div className="flex items-center">
          <Icon
            className="p-3 mr-1"
            type="customerMed"
          />
          <TextSpan
            color="indigo"
            size="sm14">
            {params.value as string}
          </TextSpan>
        </div>
      </RecordLink>
    )
  },
  {
    field: 'salesAgent',
    headerName: 'Sales Agent',
    type: 'singleSelect',
    width: 175,
    flex: 2
  },
  {
    field: 'commissionsExperienceAnalyst',
    headerName: 'CEA',
    type: 'singleSelect',
    width: 175,
    flex: 2
  },
  {
    field: 'assetCount',
    headerName: 'Asset Count',
    type: 'singleSelect',
    width: 75,
    flex: 1
  },
  {
    field: 'rpmAccountCount',
    headerName: 'RPM Account Count',
    type: 'singleSelect',
    width: 75,
    flex: 1
  }
];
